import { httpBus } from "@/api/index.js";
import dayjs from "dayjs";
import { getMinutesOfDay, getDaysInMonth } from '@/utils/timeHelper/index.js'


/**
 * 查询需量列表
 * >>> 新接口直接返回图表数据结构，不再需要前端拼接
 * >>> 查询正月的需量数据 | 查询整天的需量数据
 * @param {*} stationId 
 * @param {*} rangeType 时间范围类型 - month-获取一个月的数据，一天一个采样点  day-获取一整天的数据，一分钟一个采样点
 * @param {*} time 时间-选择的月份或天
 * @returns 
 */
export async function queryDemandMeterList({stationId, rangeType, time}) {
  const formatString = rangeType === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD';
  const date = dayjs(time).format(formatString);

  return httpBus.request("get", `/dashboard/meter/demand/analysis/getDataList`, {
    params: {
      date,  
      stationId: String(stationId),
    },
  }).then(res => {
    if (res?.data) {
      return res.data;
    } else {
      return {};
    }
  }).catch(err => {
    console.error('查询需量列表失败：',err);
    return {};
  })
}


/**
 * 获取需量曲线的配置
 * >>> 3个分组: 实际需量 | 储能需量 | 负荷需量
 * >>> 分组下每项对应一条曲线的配置
 * @param {*} stationId 
 * @returns 
 */
export async function queryLinesOption(stationId) {
  return httpBus.request("get", `/device/meter/demand/analysis/getData`, {
    params: {
      stationId: String(stationId),
    },
  }).then(res => {
    const data = {
      actualDemand: res?.data?.actualDemandList ?? [],
      energyDemand: res?.data?.energyDemandList ?? [],
      loadDemand: res?.data?.loadDemandList ?? [],
    }
    return data;
  }).catch(err => {
    console.error(err);
    const data = {
      actualDemand: [],
      energyDemand: [],
      loadDemand: [],
    }
    return data;
  });


}


// queryLinesOption(504).then(data => {
//   debugger
// })



/**
 * 创建一条需量曲线
 * @param {*} stationId 
 * @param {*} lineName 
 * @param {*} type 
 * @param {*} addMeterIds 
 * @param {*} subMeterIds 
 * @returns 
 */
export function queryCreateDemandLine({ stationId, lineName, groupType, addMeterIds, subMeterIds }) {
  return httpBus.request("post", `/device/meter/demand/analysis/saveData`, {
    data: {
      stationId: String(stationId), 
      lineName, 
      meterAddList: addMeterIds,
      meterSubtractList: subMeterIds,
      type: groupType, 
    },
  });
}


/**
 * 编辑需量曲线
 * @param {*} stationId 
 * @param {*} lineName 
 * @param {*} lineId 
 * @param {*} type 
 * @param {*} addMeterIds 
 * @param {*} subMeterIds 
 * @returns 
 */
export function queryEditDemandLine({ stationId, lineName, lineId, groupType, addMeterIds, subMeterIds }) {
  return httpBus.request("put", `/device/meter/demand/analysis/updateData`, {
    data: {
      stationId: String(stationId), 
      lineName, 
      lineUuid: lineId,
      meterAddList: addMeterIds,
      meterSubtractList: subMeterIds,
      type: groupType, 
    },
  });
}


/**
 * 删除需量曲线
 * >>> Query 参数 >>> ?id=${lineId}
 * @param {*} lineId 
 * @returns 
 */
export function queryDeleteDemandLine(lineId) {
  return httpBus.request("delete", `/device/meter/demand/analysis/deleteData?lineUuid=${lineId}`);
}












/** ======[MOCK]====================================================================================== */ 
 function mock_getMeterDemandLineData({uuid, baseData, time, rangeType}) {
  const meter = {
    uuid,
    dataList: [],
  }

  if (rangeType === 'day') {
    const list = getMinutesOfDay(time);
    list.forEach(t => {
      const point = {
        time: t,
        data: (baseData + Math.random() * 50).toFixed(2) / 1,
      }
      meter.dataList.push(point);
    })

  } else {
    const list = getDaysInMonth(time);
    list.forEach(t => {
      const point = {
        time: t,
        data: (baseData + Math.random() * 50).toFixed(2) / 1,
      }
      meter.dataList.push(point);
    })
  }

  return meter;
 }

